<template>
  <div
      class=" w-[54px] h-[54px] z-20  top-[1px] right-[1px] bg-primary-0  rounded-full  flex items-center justify-center ">
    <font-awesome-icon :icon="['fal','angle-left']" class="text-white text-3xl"/>
  </div>
</template>